var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 300,
    viewBox: "0 0 334 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11552_106954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 255.891H51.3501C53.356 255.891 55.061 257.376 55.2633 259.372C57.5192 281.62 51.0428 288.322 46.0389 290.256C45.4726 290.474 45.5365 290.747 46.1416 290.698C73.5816 288.494 88.2287 269.539 94.4671 258.087C95.1939 256.753 96.5716 255.891 98.091 255.891H295C312.673 255.891 327 241.564 327 223.891V37C327 19.3269 312.673 5 295 5H39C21.3269 5 7 19.3269 7 37V223.891C7 241.564 21.3269 255.891 39 255.891Z",
    stroke: "url(#paint0_linear_11552_106954)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11552_106954",
    x: 0.5,
    y: 0.5,
    width: 333,
    height: 298.704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.854902 0 0 0 0 0.854902 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11552_106954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11552_106954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11552_106954",
    x1: -229.839,
    y1: -60.5417,
    x2: -142.234,
    y2: 319.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443013,
    stopColor: "#202261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#543C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6939A2"
  })))));
};
export { SvgMessage as ReactComponent };
export default "data:image/svg+xml;base64,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";